import { withTranslate } from "@pathwright/ui/src/components/"
import Button from "@pathwright/ui/src/components/button/Button"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import Text from "@pathwright/ui/src/components/ui/Text"
import View from "@pathwright/ui/src/components/ui/View"
import { getIsSubscriptionUsable } from "@pathwright/web/src/modules/subscription/utils"
import { withUserCommunity } from "@pathwright/web/src/modules/user/UserCommunityContext"
// Free for subscribers.
// $10/member for non-subscribers.
import ConnectStores from "lib/core/store/components/ConnectStores"
import * as urls from "lib/core/utils/urls"

const tPrefix = "resource.about.offerings.license_form"

const ResourceLicenseOfferingFormContainer = function ({
  offering,
  licenseTo,
  includedInPlansOrProducts,
  isIncludedInGroupSubscription,
  isMultiSeatGroupSubscription,
  isIncludedForUser,
  licenseSubscribeTo,
  t
}) {
  if (!offering) {
    return null
  }

  return (
    <View padding className="ResourceOffering__Form">
      {includedInPlansOrProducts && !isIncludedForUser && (
        <View paddingBottom>
          <Text.H5>
            <Button
              styleType="blank"
              brand
              style={{ padding: 0 }}
              to={licenseSubscribeTo}
            >
              <strong>{t(`${tPrefix}.free_for_subscribers`)}</strong>
            </Button>
          </Text.H5>
        </View>
      )}
      <View paddingBottom>
        {isIncludedInGroupSubscription ? (
          <span>
            <Pathicon icon="check" />{" "}
            {t(`resource.offering_form.included`, {
              subscription: isMultiSeatGroupSubscription
                ? t("group subscription")
                : t("subscription")
            })}
          </span>
        ) : offering.licensing_mode ===
          1 /* LICENSING_MODE_PRIVATE_COHORTS */ ? (
          offering.price === 0 ? (
            <Text.H5>{t(`${tPrefix}.free`)}</Text.H5>
          ) : offering.price > 0 ? (
            <Text.H5>
              <strong>{offering.currency_display}</strong>/
              {t(`${tPrefix}.member`)}
              {includedInPlansOrProducts &&
                ` ${t(`${tPrefix}.non_subscribers`)}`}
            </Text.H5>
          ) : null
        ) : null}
      </View>

      {!isIncludedForUser &&
      offering.licensing_mode === 3 /* LICENSING_MODE_GROUP_SUBSCRIPTION */ ? (
        <Button to="/subscribe/" styleType="primary" brand>
          {t("Learn More")}
          <Pathicon icon="chevron-right" />
        </Button>
      ) : (
        <Button to={licenseTo} styleType="primary" brand>
          {t(`${tPrefix}.create_group`)}
          <Pathicon icon="chevron-right" />
        </Button>
      )}
    </View>
  )
}

ResourceLicenseOfferingFormContainer.displayName =
  "ResourceLicenseOfferingFormContainer"

const mapStateToProps = function (state, ownProps) {
  const { offering, communityGroupSubscriptions, hasActiveMembership } =
    ownProps
  const { resource, registration, registrations } = state.resourceStore.state

  const includedInPlansOrProducts =
    offering.include_in_subscription_plans.length > 0 ||
    offering.include_with_products.length > 0

  let isIncludedInGroupSubscription = false
  let isMultiSeatGroupSubscription = false

  if (offering.licensing_mode === 3 /* LICENSING_MODE_GROUP_SUBSCRIPTION */) {
    // check any community groups user is member of
    communityGroupSubscriptions.forEach((groupSubscription) => {
      if (
        // if group subscription is to a product that includes this offering
        offering.include_with_products.includes(
          groupSubscription.price.product.id
        ) &&
        // and the group subscription is active
        getIsSubscriptionUsable(groupSubscription.subscription) &&
        // and the user's membership is active
        hasActiveMembership(groupSubscription.community_group) &&
        groupSubscription.community_group.seats_available > -1
      ) {
        // then this offering is included in group subscription
        isIncludedInGroupSubscription = true
        if (groupSubscription.subscription.quantity > 1) {
          isMultiSeatGroupSubscription = true
        }
      }
    })
  }

  const isIncludedForUser =
    state.resourceStore.request.includedInUserSubscription(offering).length >
      0 || isIncludedInGroupSubscription

  const licenseTo = urls.modalRoute(
    `/library/${resource.slug}/resource/license/${offering.id}/`
  )
  // const licenseSubscribeTo = {
  //   state: { modal: true },
  //   query: { state: "subscribe" },
  //   pathname: `/library/${resource.slug}/resource/license/`
  // }

  const licenseSubscribeTo = {
    state: { modal: true },
    pathname: "/subscribe/",
    query: {
      plan_ids: encodeURIComponent(offering.include_in_subscription_plans)
    }
  }

  return _.assign(
    {},
    {
      offering,
      licenseTo,
      isIncludedForUser,
      isIncludedInGroupSubscription,
      isMultiSeatGroupSubscription,
      includedInPlansOrProducts,
      licenseSubscribeTo
    },
    ownProps
  )
}

const stores = [
  { store: "subscribe", watch: ["subscribe_state"] },
  { store: "resource", watch: ["registration"] }
]

export default withTranslate(
  withUserCommunity(
    ConnectStores(
      ResourceLicenseOfferingFormContainer,
      stores,
      {},
      mapStateToProps
    )
  )
)
